import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type VideoUploadProps = {
  selectedVideos: any[];
  totalVideos: number;
  handleClick: (index: number) => void;
  setShowAllMedia: React.Dispatch<React.SetStateAction<number | null>>;
  thumbnail?: string[];
};
const VideoUpload: React.FC<VideoUploadProps> = ({
  selectedVideos,
  totalVideos,
  handleClick,
  setShowAllMedia,
  thumbnail,
}) => {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null); // Create a ref using useRef
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);
  const isBlobUrl = (url: any) => url && url.startsWith("blob:");
  // console.log(thumbnail!);
  const _thumbnail = thumbnail || [];
  let videoHash: string, thumbnailHash: string;

  return (
    <div className="flex border w-full relative h-full">
      {selectedVideos && (
        <div className="flex w-full h-auto">
          {selectedVideos.length > 4 ? (
            <div
              className="grid grid-rows-3 grid-flow-col grid-cols-3 w-full lg:h-[400px] h-[300px]"
              // key={currentIndex * 2}
            >
              {selectedVideos?.map((video, index) => {
                const ipfsHashes = video.match(/\bQm\w{44}\b/g);

                if (ipfsHashes) {
                  [videoHash, thumbnailHash] = ipfsHashes;
                }
                return (
                  index === 0 && (
                    <div
                      className="row-span-full col-span-2 border relative overflow-hidden cursor-pointer"
                      key={index * 2}
                    >
                      {video !== undefined &&
                        (isBlobUrl(video) ? (
                          <ReactPlayer
                            ref={playerRef}
                            url={video}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={playing}
                            onPlay={play}
                            onPause={pause}
                            volume={1}
                            muted={true}
                            light={_thumbnail[index]}
                          />
                        ) : (
                          <ReactPlayer
                            ref={playerRef}
                            key={index}
                            url={ipfsGatewayImage(videoHash)}
                            width="100%"
                            height="100%"
                            controls={true}
                            playing={playing}
                            onPlay={play}
                            onPause={pause}
                            volume={1}
                            muted={true}
                            light={ipfsGatewayImage(thumbnailHash)}
                          />
                        ))}
                    </div>
                  )
                );
              })}
              {selectedVideos &&
                selectedVideos?.slice(1, 4).map((video, index) => {
                  const ipfsHashes = video.match(/\bQm\w{44}\b/g);

                  if (ipfsHashes) {
                    [videoHash, thumbnailHash] = ipfsHashes;
                  }
                  return (
                    <div
                      className="h-full relative overflow-hidden"
                      key={index * 3}
                      onClick={() => handleClick(index + 1)}
                    >
                      <div className="border w-full h-full relative cursor-pointer">
                        {video !== undefined &&
                          (isBlobUrl(video) ? (
                            <ReactPlayer
                              ref={playerRef}
                              // key={index}
                              url={video}
                              width="100%"
                              height="100%"
                              controls={true}
                              playing={playing}
                              onPlay={play}
                              onPause={pause}
                              volume={1}
                              muted={true}
                              light={_thumbnail[index]}
                            />
                          ) : (
                            <ReactPlayer
                              ref={playerRef}
                              key={index}
                              url={ipfsGatewayImage(videoHash)}
                              width="100%"
                              height="100%"
                              controls={true}
                              playing={playing}
                              onPlay={play}
                              onPause={pause}
                              volume={1}
                              muted={true}
                              light={ipfsGatewayImage(thumbnailHash)}
                            />
                          ))}
                      </div>
                      {index === selectedVideos?.slice(1, 4).length - 1 && (
                        <div
                          className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 right-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                          key={index * 4}
                          onClick={() => setShowAllMedia(4)}
                        >
                          <p>+ {selectedVideos?.length - 4}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          ) : selectedVideos && selectedVideos?.length > 3 ? (
            <div className="grid grid-cols-2 w-full h-full">
              {selectedVideos?.map((video, index) => {
                const ipfsHashes = video.match(/\bQm\w{44}\b/g);

                if (ipfsHashes) {
                  [videoHash, thumbnailHash] = ipfsHashes;
                }
                return (
                  <div
                    className={`flex w-full border border-solid relative overflow-hidden cursor-pointer h-full`}
                    key={index + 22}
                    onClick={() => handleClick(index)}
                  >
                    {video !== undefined &&
                      (isBlobUrl(video) ? (
                        <ReactPlayer
                          ref={playerRef}
                          // key={index}
                          url={video}
                          width="100%"
                          height="100%"
                          controls={true}
                          playing={playing}
                          onPlay={play}
                          onPause={pause}
                          volume={1}
                          muted={true}
                          light={_thumbnail[index]}
                          style={{height: "100%", width: "100%", objectFit: "cover", objectPosition: "center"}}
                        />
                      ) : (
                        <ReactPlayer
                          ref={playerRef}
                          key={index}
                          url={ipfsGatewayImage(videoHash)}
                          width="100%"
                          height="100%"
                          controls={true}
                          playing={playing}
                          onPlay={play}
                          onPause={pause}
                          volume={1}
                          muted={true}
                          light={ipfsGatewayImage(thumbnailHash)}
                          style={{height: "100%", width: "100%", objectFit: "cover", objectPosition: "center"}}
                        />
                      ))}
                  </div>
                );
              })}
            </div>
          ) : selectedVideos?.length === 1 ? (
            selectedVideos.map((video, index) => {
              const ipfsHashes = video.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [videoHash, thumbnailHash] = ipfsHashes;
              }
              return (
                <div
                  className="relative flex w-full flex-wrap cursor-pointer h-[176px] overflow-hidden"
                  onClick={() => handleClick(index)}
                >
                  {video !== undefined &&
                    (isBlobUrl(video) ? (
                      <ReactPlayer
                        ref={playerRef}
                        // key={index}
                        url={video}
                        // width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        // muted={true}
                        light={_thumbnail[index]}
                        // style={{ height: "100%" }}
                      />
                    ) : (
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={ipfsGatewayImage(videoHash)}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(thumbnailHash)}
                      />
                    ))}
                </div>
              );
            })
          ) : selectedVideos?.length === 2 ? (
            selectedVideos.map((video, i) => {
              const ipfsHashes = video.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [videoHash, thumbnailHash] = ipfsHashes;
              }
              return (
                <div
                  className="relative flex w-1/2 flex-wrap cursor-pointer h-[176px] overflow-hidden"
                  onClick={() => {
                    handleClick(i);
                    pause();
                  }}
                  key={i}
                >
                  {video !== undefined &&
                    (isBlobUrl(video) ? (
                      <ReactPlayer
                        ref={playerRef}
                        key={i}
                        url={video}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        style={{ height: "100%" }}
                        light={_thumbnail[i]}
                      />
                    ) : (
                      <ReactPlayer
                        ref={playerRef}
                        key={i}
                        url={ipfsGatewayImage(videoHash)}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(thumbnailHash)}
                      />
                    ))}
                </div>
              );
            })
          ) : (
            selectedVideos?.length === 3 && (
              <div className="flex w-full">
                {selectedVideos.map((video, index) => {
                  const ipfsHashes = video.match(/\bQm\w{44}\b/g);

                  if (ipfsHashes) {
                    [videoHash, thumbnailHash] = ipfsHashes;
                  }
                  return (
                    index === 0 && (
                      <div
                        className="flex w-full max-h-[400px]"
                        key={index * 20}
                      >
                        <div
                          className="w-full border relative lg:h-[400px] h-[308px] overflow-hidden cursor-pointer"
                          onClick={() => handleClick(index)}
                        >
                          {video !== undefined &&
                            (isBlobUrl(video) ? (
                              <ReactPlayer
                                ref={playerRef}
                                // key={index}
                                url={video}
                                width="100%"
                                height="100%"
                                controls={true}
                                playing={playing}
                                onPlay={play}
                                onPause={pause}
                                volume={1}
                                muted={true}
                                // muted={true}
                                light={_thumbnail[index]}
                              />
                            ) : (
                              <ReactPlayer
                                ref={playerRef}
                                key={index}
                                url={ipfsGatewayImage(videoHash)}
                                width="100%"
                                height="100%"
                                controls={true}
                                playing={playing}
                                onPlay={play}
                                onPause={pause}
                                volume={1}
                                muted={true}
                                light={ipfsGatewayImage(thumbnailHash)}
                              />
                            ))}
                        </div>
                      </div>
                    )
                  );
                })}
                <div className="grid grid-rows-2 h-auto w-full overflow-hidden">
                  {selectedVideos?.map((video, index) => {
                    const ipfsHashes = video.match(/\bQm\w{44}\b/g);

                    if (ipfsHashes) {
                      [videoHash, thumbnailHash] = ipfsHashes;
                    }
                    return (
                      index !== 0 && (
                        <div
                          className="flex w-full overflow-hidden relative h-[198px]"
                          key={index + 33}
                        >
                          <div
                            className="w-full flex-1 border flex cursor-pointer"
                            onClick={() => handleClick(index)}
                          >
                            {video !== undefined &&
                              (isBlobUrl(video) ? (
                                <ReactPlayer
                                  ref={playerRef}
                                  // key={index}
                                  url={video}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                  playing={playing}
                                  onPlay={play}
                                  onPause={pause}
                                  volume={1}
                                  muted={true}
                                  // muted={true}
                                  light={_thumbnail[index]}
                                />
                              ) : (
                                <ReactPlayer
                                  ref={playerRef}
                                  key={index}
                                  url={ipfsGatewayImage(videoHash)}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                  playing={playing}
                                  onPlay={play}
                                  onPause={pause}
                                  volume={1}
                                  muted={true}
                                  light={ipfsGatewayImage(thumbnailHash)}
                                />
                              ))}
                          </div>
                        </div>
                      )
                    );
                  })}
                </div>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default VideoUpload;
